<template>
  <div>

    <body data-anchor="pagetop" class="home page-template-default page page-id-314 wp-embed-responsive st-Grid_Container" style="overflow-y: unset;">
      <navbar follow="st-Header" imgSrc="../../../static/img/landing/logo_white.png" searchImgSrc="../../../static/img/landing/search_white.png"></navbar>
      <div class="st-FixedPoint"></div>

      <div class="st-MainContainer">
        <!-- contents -->

        <main class="st-MainContents">

          <!-- ▼▼▼▼▼ contents start ▼▼▼▼▼ -->
          <div class="top-Mv" style="text-align: center;">
            <div class="top-Mv_Slide swiper-container swiper-container-fade swiper-container-initialized swiper-container-horizontal">
              <div class="swiper-wrapper">
                <div class="swiper-slide top-Mv_Slide-item" data-swiper-autoplay="5000" data-swiper-slide-index="0">
                  <a href="javascript:void(0)">
                    <div class="top-Mv_Slide-image">
                      <div class="top-Mv_Slide-image-sp">
                        <div class="company-PageTitle_Slide-image company-PageTitle_Slide-image-image1" style="background: url(../../../static/img/landing/turnimg03.png) 50%/cover no-repeat;"></div>
                        <div class="company-PageTitle_Slide-image company-PageTitle_Slide-image-image2" style="background: url(../../../static/img/landing/turnimg03.png) 50%/cover no-repeat;"></div>
                      </div>
                      <div class="top-Mv_Slide-image-pc">
                        <div class="company-PageTitle_Slide-image company-PageTitle_Slide-image-image1" style="background: url(../../../static/img/landing/turnimg03.png) 50%/cover no-repeat;"></div>
                        <div class="company-PageTitle_Slide-image company-PageTitle_Slide-image-image2" style="background: url(../../../static/img/landing/turnimg03.png) 50%/cover no-repeat;"></div>
                      </div>
                    </div>
                  </a>
                </div>
                <div class="swiper-slide top-Mv_Slide-item" data-swiper-autoplay="5000" data-swiper-slide-index="1">
                  <a href="javascript:void(0)">
                    <div class="top-Mv_Slide-image">
                      <div class="top-Mv_Slide-image-sp">
                        <div class="company-PageTitle_Slide-image company-PageTitle_Slide-image-image1" style="background: url(../../../static/img/landing/turnimg01.png) 50%/cover no-repeat;">
                          <div style="text-align: center;">
                            <div class="pr-6 pl-6" style="padding-top:260px;color:#FFFFFF;font-size:30px">五軸マシンニングでの精密部品量産加工</div>
                          </div>
                        </div>
                        <div class="company-PageTitle_Slide-image company-PageTitle_Slide-image-image2" style="background: url(../../../static/img/landing/turnimg01.png) 50%/cover no-repeat;">
                          <div style="text-align: center;">
                            <div class="pr-6 pl-6" style="padding-top:260px;color:#FFFFFF;font-size:30px">五軸マシンニングでの精密部品量産加工</div>
                          </div>
                        </div>
                      </div>
                      <div class="top-Mv_Slide-image-pc">
                        <div class="company-PageTitle_Slide-image company-PageTitle_Slide-image-image1" style="background: url(../../../static/img/landing/turnimg01.png) 50%/cover no-repeat;">
                          <div style="text-align: center;">
                            <div class="pr-6 pl-6" style="padding-top:260px;color:#FFFFFF;font-size:30px">五軸マシンニングでの精密部品量産加工</div>
                          </div>
                        </div>
                        <div class="company-PageTitle_Slide-image company-PageTitle_Slide-image-image2" style="background: url(../../../static/img/landing/turnimg01.png) 50%/cover no-repeat;">
                          <div style="text-align: center;">
                            <div class="pr-6 pl-6" style="padding-top:260px;color:#FFFFFF;font-size:30px">五軸マシンニングでの精密部品量産加工</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
                <div class="swiper-slide top-Mv_Slide-item" data-swiper-autoplay="5000" data-swiper-slide-index="2">
                  <a href="javascript:void(0)">
                    <div class="top-Mv_Slide-image">
                      <div class="top-Mv_Slide-image-sp">
                        <div class="company-PageTitle_Slide-image company-PageTitle_Slide-image-image1" style="background: url(../../../static/img/landing/turnimg02.png) 50%/cover no-repeat;">
                          <div style="text-align: center;">
                            <div class="pr-6 pl-6" style="padding-top:260px;color:#FFFFFF;font-size:30px">自動省力化機械の設計、製造</div>
                          </div>
                        </div>
                        <div class="company-PageTitle_Slide-image company-PageTitle_Slide-image-image2" style="background: url(../../../static/img/landing/turnimg02.png) 50%/cover no-repeat;">
                          <div style="text-align: center;">
                            <div class="pr-6 pl-6" style="padding-top:260px;color:#FFFFFF;font-size:30px">自動省力化機械の設計、製造</div>
                          </div>
                        </div>
                      </div>
                      <div class="top-Mv_Slide-image-pc">
                        <div class="company-PageTitle_Slide-image company-PageTitle_Slide-image-image1" style="background: url(../../../static/img/landing/turnimg02.png) 50%/cover no-repeat;">
                          <div style="text-align: center;">
                            <div class="pr-6 pl-6" style="padding-top:260px;color:#FFFFFF;font-size:30px">自動省力化機械の設計、製造</div>
                          </div>
                        </div>
                        <div class="company-PageTitle_Slide-image company-PageTitle_Slide-image-image2" style="background: url(../../../static/img/landing/turnimg02.png) 50%/cover no-repeat;">
                          <div style="text-align: center;">
                            <div class="pr-6 pl-6" style="padding-top:260px;color:#FFFFFF;font-size:30px">自動省力化機械の設計、製造</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
                <div class="swiper-slide top-Mv_Slide-item" data-swiper-autoplay="5000" data-swiper-slide-index="3">
                  <a href="javascript:void(0)">
                    <div class="top-Mv_Slide-image">
                      <div class="top-Mv_Slide-image-sp">
                        <div class="company-PageTitle_Slide-image company-PageTitle_Slide-image-image1" style="background: url(../../../static/img/landing/turnimg04.png) 50%/cover no-repeat;"></div>
                        <div class="company-PageTitle_Slide-image company-PageTitle_Slide-image-image2" style="background: url(../../../static/img/landing/turnimg04.png) 50%/cover no-repeat;"></div>
                      </div>
                      <div class="top-Mv_Slide-image-pc">
                        <div class="company-PageTitle_Slide-image company-PageTitle_Slide-image-image1" style="background: url(../../../static/img/landing/turnimg04.png) 50%/cover no-repeat;"></div>
                        <div class="company-PageTitle_Slide-image company-PageTitle_Slide-image-image2" style="background: url(../../../static/img/landing/turnimg04.png) 50%/cover no-repeat;"></div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
              <div class="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets">
                <span @click="swiperPagination($event,0)" class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide 1">
                  <div class="circle"><svg viewBox="0 0 124 124">
                      <circle style="animation-duration:5000ms" cx="62" cy="62" r="60"></circle>
                    </svg></div>
                </span>
                <span @click="swiperPagination($event,1)" class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide 2">
                  <div class="circle"><svg viewBox="0 0 124 124">
                      <circle style="animation-duration:5000ms" cx="62" cy="62" r="60"></circle>
                    </svg></div>
                </span>
                <span @click="swiperPagination($event,2)" class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide 3">
                  <div class="circle"><svg viewBox="0 0 124 124">
                      <circle style="animation-duration:5000ms" cx="62" cy="62" r="60"></circle>
                    </svg></div>
                </span>
                <span @click="swiperPagination($event,3)" class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide 4">
                  <div class="circle"><svg viewBox="0 0 124 124">
                      <circle style="animation-duration:5000ms" cx="62" cy="62" r="60"></circle>
                    </svg></div>
                </span>
              </div>
              <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
            </div>
          </div><!-- /.top-Mv -->
          <section class="top-Product st-Grid">
            <div class="st-Grid_Inner p-0">
              <h2 class="sw-Section_Header appear" data-appear="true">
                <span class="sw-Section_Header-en"><b>
                    <font style="vertical-align: inherit;">
                      <font style="vertical-align: inherit;">GREETING</font>
                    </font>
                  </b></span>
                <span class="sw-Section_Header-ja"><b>
                    <font style="vertical-align: inherit;">
                      <font style="vertical-align: inherit;">ご挨拶</font>
                    </font>
                  </b></span>
              </h2>
            </div>

            <div class="top-Product_RowWrap p-0">
              <div class="top-Product_Row" data-appear="true">
                <div class="top-Product_Image appear" data-appear="true">
                  <div class="top-Product_Image-inner3 top-Product_Image-inner">
                    <div class="top-Product_Image-inner3-div">
                      <img style="height: auto; object-fit: scale-down;" src="../../../static/img/landing/photo.png" alt="">
                      <div class="sw-Section_Header-ja"><b>
                          <font style="vertical-align: inherit;"><br>
                            <font style="color:blue;text-align: center;">代表取締役 小山 雄</font>
                          </font>
                        </b></div>
                    </div>
                  </div>
                </div>
                <div class="top-Product_Body" data-appear="true">
                  <div class="top-Product_Body-inner">
                    <p class="top-Product_Body-text">
                      <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">組織には“全体最適“という考え方がありますが、ひとつのチーム、班、係、課、部、会社にとどまらず、</font>
                        <br />
                        <font style="vertical-align: inherit;">この社会全体が等しく発展し、そこに貢献することが私の夢です。</font>
                        <br />
                        <font style="vertical-align: inherit;"></font>
                        <br />
                        <font style="vertical-align: inherit;"></font>
                      </font>
                    </p>
                    <div class="sw-ButtonCircle">
                      <div><i class="icf el-icon-arrow-right" style="font-size:25px;bottom: 15px;"></i></div>
                    </div>
                  </div>
                </div>
              </div><!-- /top-Product_Row -->
              <div class="top-Product_ColumnWrap pl-3 pr-3 p-md-0">
                <div class="top-Product_Column" data-appear="false">
                  <div class="top-Product_Image p-0" data-appear="false">
                    <div class="top-Product_Image-inner" style="width: 100%;">
                      <img style="height:260px;background-color: white;object-fit: cover;" src="../../../static/img/landing/main1.png" alt="">
                    </div>
                  </div>
                </div>
                <div class="top-Product_Column ml-md-3" data-appear="false">
                  <div class="top-Product_Image p-0" data-appear="false">
                    <div class="top-Product_Image-inner" style="width: 100%;">
                      <img style="height:260px;background-color: white;object-fit: cover;" src="../../../static/img/landing/main2.png" alt="">
                    </div>
                  </div>
                </div>
                <div class="top-Product_Column ml-md-3" data-appear="false">
                  <div class="top-Product_Image p-0" data-appear="false">
                    <div class="top-Product_Image-inner" style="width: 100%;">
                      <img style="height:260px;background-color: white;object-fit: cover;" src="../../../static/img/landing/main3.png" alt="">
                    </div>
                  </div>
                </div>
                <div class="top-Product_Column ml-md-3" data-appear="false">
                  <div class="top-Product_Image p-0" data-appear="false">
                    <div class="top-Product_Image-inner" style="width: 100%;">
                      <img style="height:260px;background-color: white;object-fit: cover;" src="../../../static/img/landing/main4.png" alt="">
                    </div>
                  </div>
                </div>
              </div>
              <div class="st-Grid_Inner p-0" style="margin-top:150px">
                <h2 class="sw-Section_Header" data-appear="true">
                  <span class="sw-Section_Header-en"><b>
                      <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">Management Philosophy</font>
                      </font>
                    </b></span>
                  <span class="sw-Section_Header-ja"><b>
                      <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">経営理念</font>
                      </font>
                    </b></span>
                </h2>
              </div>
              <div class="top-Product_Row" data-appear="true" style="margin-top:150px">
                <div class="top-Product_Image" data-appear="true">
                  <div class="top-Product_Image-inner top-Product_Image-inner-2 ">
                    <img style="background-color: white;object-fit: cover;" src="../../../static/img/landing/picture.png" alt="">
                  </div>
                </div>
                <div class="top-Product_Body" data-appear="true">
                  <div class="top-Product_Body-inner">
                    <p class="top-Product_Body-text">
                      <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">“三方良し”という商売精神ずっと通用する。そして、</font>
                        <br />
                        <font style="vertical-align: inherit;">社員一人一人の発想力と行動力を発揮し、社会のために楽しく働こう、</font>
                        <br />
                        <font style="vertical-align: inherit;">これによって自分の人生を豊かに有意義に作り上げましょう！</font>
                        <br />
                        <font style="vertical-align: inherit;">世界トップクラスを誇るクラス日本の技術力と海外の人材、資源を活用</font>
                        <br />
                        <font style="vertical-align: inherit;">し、お客様と共に発展し、得た利益を社会に還元する。</font>
                        <br />
                        <font style="vertical-align: inherit;"></font>
                      </font>
                    </p>
                    <div class="sw-ButtonCircle">
                      <div><i class="icf el-icon-arrow-right" style="font-size:25px;bottom: 15px;"></i></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="top-Product_ColumnWrap pl-3 pr-3 p-md-1">
                <div class="top-Product_Column" data-appear="false">
                  <div class="top-Product_Image appear p-0" data-appear="false">
                    <div class="top-Product_Image-inner" style="width: 100%;">
                      <img style="height:260px;background-color: white;object-fit: cover;" src="../../../static/img/landing/product01.png" alt="">
                    </div>
                  </div>
                </div>
                <div class="top-Product_Column ml-md-3" data-appear="false">
                  <div class="top-Product_Image appear p-0" data-appear="false">
                    <div class="top-Product_Image-inner" style="width: 100%;">
                      <img style="height:260px;background-color: white;object-fit: cover;" src="../../../static/img/landing/product02.png" alt="">
                    </div>
                  </div>
                </div>
                <div class="top-Product_Column ml-md-3" data-appear="false">
                  <div class="top-Product_Image appear p-0" data-appear="false">
                    <div class="top-Product_Image-inner" style="width: 100%;">
                      <img style="height:260px;background-color: white;object-fit: cover;" src="../../../static/img/landing/product03.png" alt="">
                    </div>
                  </div>
                </div>
              </div>
              <div class="top-Product_ColumnWrap pl-3 pr-3 p-md-1">
                <div class="top-Product_Column" data-appear="false">
                  <div class="top-Product_Image appear p-0" data-appear="false">
                    <div class="top-Product_Image-inner" style="width: 100%;">
                      <img style="height:260px;background-color: white;object-fit: cover;" src="../../../static/img/landing/product04.png" alt="">
                    </div>
                  </div>
                </div>
                <div class="top-Product_Column ml-md-3" data-appear="false">
                  <div class="top-Product_Image appear p-0" data-appear="false">
                    <div class="top-Product_Image-inner" style="width: 100%;">
                      <img style="height:260px;background-color: white;object-fit: cover;" src="../../../static/img/landing/product05.png" alt="">
                    </div>
                  </div>
                </div>
                <div class="top-Product_Column ml-md-3" data-appear="false">
                  <div class="top-Product_Image appear p-0" data-appear="false">
                    <div class="top-Product_Image-inner" style="width: 100%;">
                      <img style="height:260px;background-color: white;object-fit: cover;" src="../../../static/img/landing/product06.png" alt="">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
      <copyright></copyright>
    </body>
  </div>
</template>
<style />
<script type="text/javascript">
import copyright from './copyright'
import navbar from './navbar'
import Swiper from 'swiper/swiper-bundle.js'
import 'swiper/swiper-bundle.css'

// import navbar from './navbar'

export default {
  components: { copyright, navbar },
  data: function () {
    return {
      mySwiper: '',
      mySwiperNews: '',
      newsData: [
        { id: 1, lavel: 'COMPANY', date: '2019.10.30', imgSrc: 'url(../../../../static/img/landing/bli01.jpg)', link: '/news/news-company-detail' },
        { id: 2, lavel: 'PRODUCT', date: '2020.10.30', imgSrc: 'url(../../../../static/img/landing/product02.png)', link: '/news/news-product-detail' },
        { id: 3, lavel: 'COMPANY', date: '2019.10.30', imgSrc: 'url(../../../../static/img/landing/bli01.jpg)', link: '/news/news-company-detail' },
        { id: 4, lavel: 'PRODUCT', date: '2019.10.30', imgSrc: 'url(../../../../static/img/landing/product02.png)', link: '/news/news-product-detail' }
      ]
    }
  },
  mounted() {
    this.init()
  },
  methods: {

    swiperPagination(event, index) {
      this.mySwiper.slideTo(index + 1)
    },
    init() {
      let mySwiperNewsSettings = {
        slidesPerView: 'auto',
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
      this.mySwiperNews = new Swiper('.swiper-container-news', mySwiperNewsSettings)

      this.mySwiper = new Swiper('.top-Mv_Slide', {
        autoplay: {
          disableOnInteraction: false
        },
        loop: true,
        effect: 'fade',
        on: {
          slideChangeTransitionStart: function(event) {
            $('.swiper-pagination-bullet').removeClass('swiper-pagination-bullet-active')
            $($('.swiper-pagination-bullet')[event.realIndex]).addClass('swiper-pagination-bullet-active')
          }
        }
      })
      $('.st-Grid_Inner').eq(0).addClass('st-Grid_Inner_appear')
      window.onresize = () => {
        let viewW = $(window).width()
        if (viewW < 1200) {
          this.mySwiperNews.params.slidesPerView = 1
        } else {
          this.mySwiperNews.params.slidesPerView = 3
        }
        // this.mySwiperNews = new Swiper('.swiper-container-news', mySwiperNewsSettings)
      }

      $(document).scroll(() => {
        let scroH = $(document).scrollTop()
        let viewW = $(window).width()
        console.log(scroH)
        // var contentH = $(document).height()
        // 769px
        // console.log(viewW)
        if (scroH > 50) {
          $('.st-Header').addClass('is-follow')
          $('.st-Hd_Logo a img').attr('src', '../../../static/img/landing/logo_black.png')
          $('.st-Nav_Search a img').attr('src', '../../../static/img/landing/search_black.png')
          $('.st-Footer_Pagetop').addClass('is-follow')
        } else {
          $('.st-Header').removeClass('is-follow')
          $('.st-Hd_Logo a img').attr('src', '../../../static/img/landing/logo_white.png')
          $('.st-Nav_Search a img').attr('src', '../../../static/img/landing/search_white.png')
          $('.st-Footer_Pagetop').removeClass('is-follow')
        }
        if (viewW > 769) {
          if (scroH > 800) {
          // $('.st-Grid_Inner').eq(0).css('cssText', 'transform: scaleX(0);')
            $('.sw-Section_Header').eq(0).removeClass('appear')
            $('.st-Grid_Inner').eq(0).removeClass('st-Grid_Inner_appear')
          } else {
          // $('.st-Grid_Inner').eq(0).css('cssText', 'transform: scaleX(1);')
            $('.sw-Section_Header').eq(0).addClass('appear')
            $('.st-Grid_Inner').eq(0).addClass('st-Grid_Inner_appear')
          }
          if (scroH >= 0 && scroH < 1300) {
            $('.top-Product_Image').eq(0).addClass('appear')
          } else {
            $('.top-Product_Image').eq(0).removeClass('appear')
          }
          if ((scroH >= 900 && scroH <= 1300) || (scroH >= 50 && scroH <= 1300)) {
            $('.top-Product_Body').eq(0).addClass('appear')
          } else {
            $('.top-Product_Body').eq(0).removeClass('appear')
          }
          if ((scroH >= 1100 && scroH <= 1350) || (scroH >= 400 && scroH <= 1350)) {
            $('.top-Product_Row').eq(0).addClass('appear')
          } else {
            $('.top-Product_Row').eq(0).removeClass('appear')
          }

          if (scroH >= 600 && scroH <= 1800) {
            $('.top-Product_Image').eq(1).addClass('appear')
            $('.top-Product_Image').eq(2).addClass('appear')
            $('.top-Product_Image').eq(3).addClass('appear')
            $('.top-Product_Image').eq(4).addClass('appear')
          } else {
            $('.top-Product_Image').eq(1).removeClass('appear')
            $('.top-Product_Image').eq(2).removeClass('appear')
            $('.top-Product_Image').eq(3).removeClass('appear')
            $('.top-Product_Image').eq(4).removeClass('appear')
          }

          if (scroH >= 1000 && scroH <= 2000) {
            $('.sw-Section_Header').eq(1).addClass('appear')
            $('.st-Grid_Inner').eq(1).addClass('st-Grid_Inner_appear')
          } else {
            $('.sw-Section_Header').eq(1).removeClass('appear')
            $('.st-Grid_Inner').eq(1).removeClass('st-Grid_Inner_appear')
          }

          if (scroH >= 1300 && scroH <= 2500) {
            $('.top-Product_Image').eq(5).addClass('appear')
            $('.top-Product_Body').eq(1).addClass('appear')
            $('.top-Product_Row').eq(1).addClass('appear')
          } else {
            $('.top-Product_Image').eq(5).removeClass('appear')
            $('.top-Product_Body').eq(1).removeClass('appear')
            $('.top-Product_Row').eq(1).removeClass('appear')
          }

          if (scroH >= 1800 && scroH <= 3300) {
            $('.top-Product_Image').eq(6).addClass('appear')
            $('.top-Product_Image').eq(7).addClass('appear')
            $('.top-Product_Image').eq(8).addClass('appear')
            $('.top-Product_Image').eq(9).addClass('appear')
            $('.top-Product_Image').eq(10).addClass('appear')
            $('.top-Product_Image').eq(11).addClass('appear')
          } else {
            $('.top-Product_Image').eq(6).removeClass('appear')
            $('.top-Product_Image').eq(7).removeClass('appear')
            $('.top-Product_Image').eq(8).removeClass('appear')
            $('.top-Product_Image').eq(9).removeClass('appear')
            $('.top-Product_Image').eq(10).removeClass('appear')
            $('.top-Product_Image').eq(11).removeClass('appear')
          }

          if (scroH >= 2400 && scroH <= 3600) {
            $('.sw-Section_Header').eq(2).addClass('appear')
            $('.st-Grid_Inner').eq(2).addClass('st-Grid_Inner_appear')
          } else {
            $('.sw-Section_Header').eq(2).removeClass('appear')
            $('.st-Grid_Inner').eq(2).removeClass('st-Grid_Inner_appear')
          }

          if (scroH >= 2600 && scroH <= 4000) {
            $('.swiper-container-news').addClass('appear')
          } else {
            $('.swiper-container-news').removeClass('appear')
          }
        } else {
          if (scroH > 800) {
          // $('.st-Grid_Inner').eq(0).css('cssText', 'transform: scaleX(0);')
            $('.sw-Section_Header').eq(0).removeClass('appear')
            $('.st-Grid_Inner').eq(0).removeClass('st-Grid_Inner_appear')
          } else {
          // $('.st-Grid_Inner').eq(0).css('cssText', 'transform: scaleX(1);')
            $('.sw-Section_Header').eq(0).addClass('appear')
            $('.st-Grid_Inner').eq(0).addClass('st-Grid_Inner_appear')
          }
          if (scroH >= 0 && scroH < 1300) {
            $('.top-Product_Image').eq(0).addClass('appear')
          } else {
            $('.top-Product_Image').eq(0).removeClass('appear')
          }
          if ((scroH >= 900 && scroH <= 1300) || (scroH >= 50 && scroH <= 1300)) {
            $('.top-Product_Body').eq(0).addClass('appear')
          } else {
            $('.top-Product_Body').eq(0).removeClass('appear')
          }
          if ((scroH >= 1100 && scroH <= 1350) || (scroH >= 400 && scroH <= 1350)) {
            $('.top-Product_Row').eq(0).addClass('appear')
          } else {
            $('.top-Product_Row').eq(0).removeClass('appear')
          }

          if (scroH >= 500 && scroH <= 2500) {
            $('.top-Product_Image').eq(1).addClass('appear')
            $('.top-Product_Image').eq(2).addClass('appear')
            $('.top-Product_Image').eq(3).addClass('appear')
            $('.top-Product_Image').eq(4).addClass('appear')
          } else {
            $('.top-Product_Image').eq(1).removeClass('appear')
            $('.top-Product_Image').eq(2).removeClass('appear')
            $('.top-Product_Image').eq(3).removeClass('appear')
            $('.top-Product_Image').eq(4).removeClass('appear')
          }

          if (scroH >= 1700 && scroH <= 2700) {
            $('.sw-Section_Header').eq(1).addClass('appear')
            $('.st-Grid_Inner').eq(1).addClass('st-Grid_Inner_appear')
          } else {
            $('.sw-Section_Header').eq(1).removeClass('appear')
            $('.st-Grid_Inner').eq(1).removeClass('st-Grid_Inner_appear')
          }

          if (scroH >= 2000 && scroH <= 3500) {
            $('.top-Product_Image').eq(5).addClass('appear')
            $('.top-Product_Body').eq(1).addClass('appear')
            $('.top-Product_Row').eq(1).addClass('appear')
          } else {
            $('.top-Product_Image').eq(5).removeClass('appear')
            $('.top-Product_Body').eq(1).removeClass('appear')
            $('.top-Product_Row').eq(1).removeClass('appear')
          }

          if (scroH >= 2700 && scroH <= 5500) {
            $('.top-Product_Image').eq(6).addClass('appear')
            $('.top-Product_Image').eq(7).addClass('appear')
            $('.top-Product_Image').eq(8).addClass('appear')
          } else {
            $('.top-Product_Image').eq(6).removeClass('appear')
            $('.top-Product_Image').eq(7).removeClass('appear')
            $('.top-Product_Image').eq(8).removeClass('appear')
          }

          if (scroH >= 4700 && scroH <= 5700) {
            $('.sw-Section_Header').eq(2).addClass('appear')
            $('.st-Grid_Inner').eq(2).addClass('st-Grid_Inner_appear')
          } else {
            $('.sw-Section_Header').eq(2).removeClass('appear')
            $('.st-Grid_Inner').eq(2).removeClass('st-Grid_Inner_appear')
          }

          if (scroH >= 4900 && scroH <= 7000) {
            $('.swiper-container-news').addClass('appear')
          } else {
            $('.swiper-container-news').removeClass('appear')
          }
        }

        // appear
      })
    }
  }
}
</script>
<style scoped>
  .top-Product_Image-inner3 {
      height:500px;
    }
  .top-Product_Image-inner3-div {
      height: 230px;
      width: 230px;
      text-align: center;
    }
  @media screen and (max-width:769px){
    .top-Product_Row .top-Product_Image-inner3 {
      padding-left: unset;
      padding-top: 50px;
      padding-bottom: 50px;
      text-align: center;
      height:420px;
    }
    .top-Product_Image-inner3-div {
      margin: auto;
    }
  }

 .waterImg {

    margin: auto;

    font-style: normal;
    font-weight: 400;
    line-height: 1;
    font-smoothing: antialiased;
    -webkit-animation: logoT 2s ease-out infinite;
    animation: logoT 2s ease-out infinite;
    --p3d: perspective(20em);
  }

  @keyframes logoT {
    0% {
      opacity: 0
    }

    32% {
      opacity: 0.2
    }

    33% {
      -webkit-transform: translateY(0px);
      transform: translateY(0px);
      opacity: 1
    }

    38%,
    100% {
      -webkit-transform: translateY(78px);
      transform: translateY(78px);
    }

    100% {
      opacity: 0
    }
  }
  @media screen and (max-width: 769px){
    @keyframes logoT {
    0% {
      opacity: 0
    }

    32% {
      opacity: 0.2
    }

    33% {
      -webkit-transform: translateY(0px);
      transform: translateY(0px);
      opacity: 1
    }

    38%,
    100% {
      -webkit-transform: translateY(58px);
      transform: translateY(58px);
    }

    100% {
      opacity: 0
    }
  }
  }

  .watercanv {
    display: grid;
    place-content: end center;
    overflow: hidden;
    margin: 0;
  }

  .canv {
    --rdist: calc(1em*var(--f));
    --p3d: perspective(20em);
    position: relative;
    padding: calc(var(--rdist) + 1em);
    background: Transparent;
    filter: blue;
    animation: fall 2s ease-in infinite;
    width: 100%
  }

  @keyframes fall {
    0% {
      transform: var(--p3d) translatey(-100vh) scale(0) rotatex(0deg);
    }

    32% {
      transform: var(--p3d) translatey(0) scale(0, 0) rotatex(0deg);
    }

    33% {
      transform: var(--p3d) translatey(0) scale(0, 0) rotatex(0deg);
    }

    35%,
    100% {
      transform: var(--p3d) translatey(0) scale(1) rotatex(75deg);
    }
  }

  .drop {
    --rdrop: calc(var(--s)*1em);
    --adrop: var(--k)*1turn/var(--n);
    position: absolute;
    top: 50%;
    left: 50%;
    margin: calc(-1*var(--rdrop));
    padding: var(--rdrop);
    border-radius: 50%;
    transform: rotate(calc(var(--adrop) - 45deg)) translate(var(--rdist)) scale(0, calc(var(--s)*.5));
    background: dodgerblue;
    filter: blur(5px);
    animation: wave 2s ease-out infinite;
  }
   @keyframes wave {

    0%,
    32% {
      border-radius: 3px 25% 25% 75%;
      transform: rotate(-45deg) translatey(calc(var(--s)*1em)) scale(1);
    }

    35% {
      border-radius: 50%;
      transform: rotate(calc(var(--adrop) - 45deg)) translate(0) scale(1);
    }
  }
.company-PageTitle_Slide-image {
  z-index: 10;
  opacity: 0;
  width: 114%;
  height: 114%;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  left: -7%;
  top: -7%;
  -webkit-animation: company-slide 12s 0s infinite;
  animation: company-slide 12s 0s infinite;
}

.company-PageTitle_Slide-image:nth-child(2) {
  -webkit-animation-delay: 6s;
  animation-delay: 6s
}
/**.top-Mv_Slide .swiper-pagination-bullet:before {
    background-color: red;
}
.top-Mv_Slide .swiper-pagination-bullet .circle svg circle {
    fill: rgba(0, 0, 0, 0);
    stroke: red;

}**/
@media screen and (min-width: 769px){
.top-Product_Row:nth-child(odd):after, .top-Product_Row:nth-child(odd):before {
    left: 50.8%;
}
}
@media screen and (min-width: 769px){
.top-Product_Row:nth-child(2n):after, .top-Product_Row:nth-child(2n):before {
    right: 46%;
}
}

.st-MainContents {
  padding-top: 0px !important;
}

@media screen and (min-width: 769px) {
  .st-MainContents {
    padding-top:0px !important;
  }
}
.top-Mv_Slide a {
    display: block;
    height: calc(100% + 5px);
}
  .sw-ButtonRound a {
    padding: 18px 50px;
    min-width: 160px;
    background-color: #c7000b;
  }

  .sw-ButtonRound a span {
    margin-left: -25px
  }

  .sw-ButtonRound a span,
  .sw-ButtonRound a i {
    background-color: #c7000b;
    color: #FFFFFF;
  }
  .top-News .sw-Section_Header-en {
    font-size: 32px;
  }

  .top-News .sw-Section_Header-ja {
    font-size: 18px;
  }
  .top-Product .sw-Section_Header-en {
    font-size: 32px;
  }

  .top-Product .sw-Section_Header-ja {
    font-size: 18px;
  }
 a {
    border-bottom-style: none;
  }
.swiper-slide-news a{
  border-bottom-style: none;
}
.top-Product_Image-inner img{
  width:100%
}
.swiper-slide-news{
  width: 360px!important;
  margin-right: 60px!important;
}
  .st-Grid_Inner:before {
    content: "";
    width: 20vw;
    height: 5px;
    position: absolute;
    bottom: 0;
    transform: scale(1);
    transform: scaleX(0);
    -webkit-transition: -webkit-transform 3s cubic-bezier(.23, 1, .32, 1);
    transition: -webkit-transform 3s cubic-bezier(.23, 1, .32, 1);
    -o-transition: transform 3s cubic-bezier(.23, 1, .32, 1);
    transition: transform 3s cubic-bezier(.23, 1, .32, 1);
    transition: transform 3s cubic-bezier(.23, 1, .32, 1), -webkit-transform 3s cubic-bezier(.23, 1, .32, 1);
        transform-origin: left top;
        top: 81px;
  }
  .st-Grid_Inner:after {
    content: "";
    width: 100%;
    height: 3px;
    position: absolute;
    bottom: 0;
    transform: scale(1);
    background-color: #c7000b;
    transform: scaleX(0);
    -webkit-transition: -webkit-transform 3s cubic-bezier(.23, 1, .32, 1);
    transition: -webkit-transform 3s cubic-bezier(.23, 1, .32, 1);
    -o-transition: transform 3s cubic-bezier(.23, 1, .32, 1);
    transition: transform 3s cubic-bezier(.23, 1, .32, 1);
    transition: transform 3s cubic-bezier(.23, 1, .32, 1), -webkit-transform 3s cubic-bezier(.23, 1, .32, 1);
        transform-origin: left top;
    top: 83px;
  }
  .top-Product_Image-inner img{
    height:320px;
  }
  .swiper-button-next i:before,
  .swiper-button-prev i:before {
    font-size: 1.6rem;
    height: 25px;
    line-height: 25px;
    letter-spacing: 0;
    font-weight: bold;
  }
@media screen and (max-width: 769px){
  .top-Mv_Slide-image-sp {
    display: block
  }
  .top-Mv_Slide-image-pc {
    display: none
  }
}
@media screen and (min-width: 769px){
  .top-Mv_Slide-image-sp {
    display: none
  }
  .top-Mv_Slide-image-pc {
    display: block
  }
 .st-News_Slide .swiper-button-next i:before,
    .st-News_Slide .swiper-button-prev i:before {
      font-size: 2.5rem;
      height: 25px;
      line-height: 25px;
      letter-spacing: 0;
      font-weight: bold;
    }
  .top-Product_Body{
    width: 520px;
  }
  .top-Product_Body-inner{
    width: 600px;
  }
  .top-Product_Image-inner{
    width:80%
  }
  .top-Product_Image-inner img{
    height:450px;
  }
  .st-Grid_Inner:before {
    width: 10vw;
  }
  .st-Grid_Inner:after {
    width: 100%;
  }
  .top-Product_Image{
    padding: 0 40px
  }
  .top-Product_Row{
    padding: 0 40px
  }
  .top-Product_Image-inner-2{
    margin-left:239px
  }
}

  .top-Mv_Slide .swiper-pagination {
    justify-content: center;
    margin-bottom: 10px;
  }
  .top-Mv_Slide-image video {
    width: 100vw;
    height: auto;
  }
  .st-Grid_Inner_appear:before{
    transform: scaleX(1) !important;
  }
    .st-Grid_Inner_appear:after{
    transform: scaleX(1) !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/landing.vue